module.exports = __webpack_public_path__ + "img/5085e58.png";